
// https://keepa.com/#!discuss/t/product-finder/5473
// (keepa uses a spec super-set of typescript where numbers have a size, because
// their backend is probably Java and has sized integers. I left comments for what
// integer types are used when re-mapping these to ts 'number')
export class KeepaQueryJSON {
  "page": number; // Integer
  "perPage": number; // Integer
  "sort": string[][]; // https://keepa.com/#!discuss/t/product-finder/5473#p-7800-sorting-3

  "rootCategory": number; // Long
  "categories_include": number[]; // Long array
  "categories_exclude": number[]; // Long array
  "salesRankReference": number; // Long
  "manufacturer": string[]; // String array
  "title": string;
  "singleVariation": boolean;
  "lastPriceChange_lte": number; // Integer <-- actually a date!
  "lastPriceChange_gte": number; // Integer <-- actually a date!
  "lastOffersUpdate_lte": number; // Integer <-- actually a date!
  "lastOffersUpdate_gte": number; // Integer	<-- date!
  "isLowestOffer": boolean;	
  "productType": number; // Integer
  "hasParentASIN": boolean;
  "availabilityAmazon": number[]; // Integer array
  "returnRate": number[]; // Integer array
  "hasReviews": boolean;
  "trackingSince_lte": number; // Integer <-- date!
  "trackingSince_gte": number; // Integer <-- date!
  "brand": string[]; // String array
  "productGroup": string[]; // String array
  "partNumber": string[]; // String array
  "model": string[]; // String array
  "color": string[]; // String array
  "size": string[]; // String array
  "edition": string[]; // String array
  "format": string[]; // String array
  "packageHeight_lte": number; // Integer
  "packageHeight_gte": number; // Integer
  "packageLength_lte": number; // Integer
  "packageLength_gte": number; // Integer
  "packageWidth_lte": number; // Integer
  "packageWidth_gte": number; // Integer
  "packageWeight_lte": number; // Integer
  "packageWeight_gte": number; // Integer,
  "itemHeight_lte": number; // Integer
  "itemHeight_gte": number; // Integer
  "itemLength_lte": number; // Integer
  "itemLength_gte": number; // Integer
  "itemWidth_lte": number; // Integer
  "itemWidth_gte": number; // Integer
  "itemWeight_lte": number; // Integer
  "itemWeight_gte": number; // Integer
  "variationCount_lte": number; // Integer
  "variationCount_gte": number; // Integer
  "imageCount_lte": number; // Integer
  "imageCount_gte": number; // Integer
  "buyBoxStatsAmazon30_lte": number; // Integer
  "buyBoxStatsAmazon30_gte": number; // Integer
  "buyBoxStatsAmazon90_lte": number; // Integer
  "buyBoxStatsAmazon90_gte": number; // Integer
  "buyBoxStatsAmazon180_lte": number; // Integer
  "buyBoxStatsAmazon180_gte": number; // Integer
  "buyBoxStatsAmazon365_lte": number; // Integer
  "buyBoxStatsAmazon365_gte": number; // Integer
  "buyBoxStatsTopSeller30_lte": number; // Integer
  "buyBoxStatsTopSeller30_gte": number; // Integer
  "buyBoxStatsTopSeller90_lte": number; // Integer
  "buyBoxStatsTopSeller90_gte": number; // Integer
  "buyBoxStatsTopSeller180_lte": number; // Integer
  "buyBoxStatsTopSeller180_gte": number; // Integer
  "buyBoxStatsTopSeller365_lte": number; // Integer
  "buyBoxStatsTopSeller365_gte": number; // Integer
  "buyBoxStatsSellerCount30_lte": number; // Integer
  "buyBoxStatsSellerCount30_gte": number; // Integer
  "buyBoxStatsSellerCount90_lte": number; // Integer
  "buyBoxStatsSellerCount90_gte": number; // Integer
  "buyBoxStatsSellerCount180_lte": number; // Integer
  "buyBoxStatsSellerCount180_gte": number; // Integer
  "buyBoxStatsSellerCount365_lte": number; // Integer
  "buyBoxStatsSellerCount365_gte": number; // Integer
  "outOfStockPercentage90_lte": number; // Integer
  "outOfStockPercentage90_gte": number; // Integer
  "variationReviewCount_lte": number; // Integer
  "variationReviewCount_gte": number; // Integer
  "variationRatingCount_lte": number; // Integer
  "variationRatingCount_gte": number; // Integer
  "deltaPercent90_monthlySold_lte": number; // Integer
  "deltaPercent90_monthlySold_gte": number; // Integer
  "outOfStockCountAmazon30_lte": number; // Integer
  "outOfStockCountAmazon30_gte": number; // Integer
  "outOfStockCountAmazon90_lte": number; // Integer
  "outOfStockCountAmazon90_gte": number; // Integer
  "isHazMat": boolean;
  "isHeatSensitive": boolean;
  "isAdultProduct": boolean;
  "isEligibleForTradeIn": boolean;
  "isEligibleForSuperSaverShipping": boolean;
  "isSNS": boolean;
  "launchpad": boolean;
  "buyBoxIsPreorder": boolean;
  "buyBoxIsBackorder": boolean;
  "buyBoxIsPrimeExclusive": boolean;
  "author": string[]; // String array
  "binding": string[]; // String array
  "genre": string[]; // String array
  "languages": string[]; // String array
  "label": string[]; // String array
  "publisher": string[]; // String array
  "platform": string[]; // String array
  "activeIngredients": string[]; // String array
  "specialIngredients": string[]; // String array
  "itemTypeKeyword": string[]; // String array
  "targetAudienceKeyword": string[]; // String array
  "itemForm": string[]; // String array
  "scent": string[]; // String array
  "unitType": string[]; // String array
  "pattern": string[]; // String array
  "style": string[]; // String array
  "material": string[]; // String array
  "couponOneTimeAbsolute_lte": number; // Integer
  "couponOneTimeAbsolute_gte": number; // Integer
  "couponOneTimePercent_lte": number; // Integer
  "couponOneTimePercent_gte": number; // Integer
  "couponSNSPercent_lte": number; // Integer
  "couponSNSPercent_gte": number; // Integer
  "flipability30_lte": number; // Byte
  "flipability30_gte": number; // Byte
  "flipability90_lte": number; // Byte
  "flipability90_gte": number; // Byte
  "flipability365_lte": number; // Byte
  "flipability365_gte": number; // Byte
  "businessDiscount_lte": number; // Byte
  "businessDiscount_gte": number; // Byte
  "batteriesRequired": boolean;
  "batteriesIncluded": boolean;
  "isMerchOnDemand": boolean;
  "hasMainVideo": boolean;
  "hasAPlus": boolean;
  "hasAPlusFromManufacturer": boolean;
  "videoCount_lte": number; // Byte
  "videoCount_gte": number; // Byte
  "brandStoreName": string[]; // String array
  "brandStoreUrlName": string[]; // String array
  "buyBoxIsAmazon": boolean;
  "buyBoxIsFBA": boolean;
  "buyBoxIsUnqualified": boolean;
  "buyBoxSellerId": string[]; // String array
  "buyBoxUsedCondition": number[]; // Integer array
  "buyBoxUsedIsFBA": boolean;
  "buyBoxUsedSellerId": string[]; // String array
  "sellerIds": string[]; // String array
  "sellerIdsLowestFBA": string[]; // String array
  "sellerIdsLowestFBM": string[]; // String array
  "numberOfItems_lte": number; // Integer
  "numberOfItems_gte": number; // Integer
  "numberOfPages_lte": number; // Integer
  "numberOfPages_gte": number; // Integer
  "publicationDate_lte": number; // Integer
  "publicationDate_gte": number; // Integer
  "releaseDate_lte": number; // Integer
  "releaseDate_gte": number; // Integer
  "isPrimeExclusive": boolean;
  "lightningEnd_lte": number; // Integer
  "lightningEnd_gte": number; // Integer
  "monthlySold_lte": number; // Integer
  "monthlySold_gte": number; // Integer
  "current_AMAZON_lte": number; // Integer
  "current_AMAZON_gte": number; // Integer
  "current_NEW_lte": number; // Integer
  "current_NEW_gte": number; // Integer
  "current_USED_lte": number; // Integer
  "current_USED_gte": number; // Integer
  "current_SALES_lte": number; // Integer
  "current_SALES_gte": number; // Integer
  "current_LISTPRICE_lte": number; // Integer
  "current_LISTPRICE_gte": number; // Integer
  "current_COLLECTIBLE_lte": number; // Integer
  "current_COLLECTIBLE_gte": number; // Integer
  "current_REFURBISHED_lte": number; // Integer
  "current_REFURBISHED_gte": number; // Integer
  "current_NEW_FBM_SHIPPING_lte": number; // Integer
  "current_NEW_FBM_SHIPPING_gte": number; // Integer
  "current_LIGHTNING_DEAL_lte": number; // Integer
  "current_LIGHTNING_DEAL_gte": number; // Integer
  "current_WAREHOUSE_lte": number; // Integer
  "current_WAREHOUSE_gte": number; // Integer
  "current_NEW_FBA_lte": number; // Integer
  "current_NEW_FBA_gte": number; // Integer
  "current_COUNT_NEW_lte": number; // Integer
  "current_COUNT_NEW_gte": number; // Integer
  "current_COUNT_USED_lte": number; // Integer
  "current_COUNT_USED_gte": number; // Integer
  "current_COUNT_REFURBISHED_lte": number; // Integer
  "current_COUNT_REFURBISHED_gte": number; // Integer
  "current_COUNT_COLLECTIBLE_lte": number; // Integer
  "current_COUNT_COLLECTIBLE_gte": number; // Integer
  "current_RATING_lte": number; // Integer
  "current_RATING_gte": number; // Integer
  "current_COUNT_REVIEWS_lte": number; // Integer
  "current_COUNT_REVIEWS_gte": number; // Integer
  "current_BUY_BOX_SHIPPING_lte": number; // Integer
  "current_BUY_BOX_SHIPPING_gte": number; // Integer
  "current_USED_NEW_SHIPPING_lte": number; // Integer
  "current_USED_NEW_SHIPPING_gte": number; // Integer
  "current_USED_VERY_GOOD_SHIPPING_lte": number; // Integer
  "current_USED_VERY_GOOD_SHIPPING_gte": number; // Integer
  "current_USED_GOOD_SHIPPING_lte": number; // Integer
  "current_USED_GOOD_SHIPPING_gte": number; // Integer
  "current_USED_ACCEPTABLE_SHIPPING_lte": number; // Integer
  "current_USED_ACCEPTABLE_SHIPPING_gte": number; // Integer
  "current_REFURBISHED_SHIPPING_lte": number; // Integer
  "current_REFURBISHED_SHIPPING_gte": number; // Integer
  "current_TRADE_IN_lte": number; // Integer
  "current_TRADE_IN_gte": number; // Integer
  "delta90_AMAZON_lte": number; // Integer
  "delta90_AMAZON_gte": number; // Integer
  "delta90_NEW_lte": number; // Integer
  "delta90_NEW_gte": number; // Integer
  "delta90_USED_lte": number; // Integer
  "delta90_USED_gte": number; // Integer
  "delta90_SALES_lte": number; // Integer
  "delta90_SALES_gte": number; // Integer
  "delta90_LISTPRICE_lte": number; // Integer
  "delta90_LISTPRICE_gte": number; // Integer
  "delta90_COLLECTIBLE_lte": number; // Integer
  "delta90_COLLECTIBLE_gte": number; // Integer
  "delta90_REFURBISHED_lte": number; // Integer
  "delta90_REFURBISHED_gte": number; // Integer
  "delta90_NEW_FBM_SHIPPING_lte": number; // Integer
  "delta90_NEW_FBM_SHIPPING_gte": number; // Integer
  "delta90_LIGHTNING_DEAL_lte": number; // Integer
  "delta90_LIGHTNING_DEAL_gte": number; // Integer
  "delta90_WAREHOUSE_lte": number; // Integer
  "delta90_WAREHOUSE_gte": number; // Integer
  "delta90_NEW_FBA_lte": number; // Integer
  "delta90_NEW_FBA_gte": number; // Integer
  "delta90_COUNT_NEW_lte": number; // Integer
  "delta90_COUNT_NEW_gte": number; // Integer
  "delta90_COUNT_USED_lte": number; // Integer
  "delta90_COUNT_USED_gte": number; // Integer
  "delta90_COUNT_REFURBISHED_lte": number; // Integer
  "delta90_COUNT_REFURBISHED_gte": number; // Integer
  "delta90_COUNT_COLLECTIBLE_lte": number; // Integer
  "delta90_COUNT_COLLECTIBLE_gte": number; // Integer
  "delta90_RATING_lte": number; // Integer
  "delta90_RATING_gte": number; // Integer
  "delta90_COUNT_REVIEWS_lte": number; // Integer
  "delta90_COUNT_REVIEWS_gte": number; // Integer
  "delta90_BUY_BOX_SHIPPING_lte": number; // Integer
  "delta90_BUY_BOX_SHIPPING_gte": number; // Integer
  "delta90_USED_NEW_SHIPPING_lte": number; // Integer
  "delta90_USED_NEW_SHIPPING_gte": number; // Integer
  "delta90_USED_VERY_GOOD_SHIPPING_lte": number; // Integer
  "delta90_USED_VERY_GOOD_SHIPPING_gte": number; // Integer
  "delta90_USED_GOOD_SHIPPING_lte": number; // Integer
  "delta90_USED_GOOD_SHIPPING_gte": number; // Integer
  "delta90_USED_ACCEPTABLE_SHIPPING_lte": number; // Integer
  "delta90_USED_ACCEPTABLE_SHIPPING_gte": number; // Integer
  "delta90_REFURBISHED_SHIPPING_lte": number; // Integer
  "delta90_REFURBISHED_SHIPPING_gte": number; // Integer
  "delta90_TRADE_IN_lte": number; // Integer
  "delta90_TRADE_IN_gte": number; // Integer
  "delta30_AMAZON_lte": number; // Integer
  "delta30_AMAZON_gte": number; // Integer
  "delta30_NEW_lte": number; // Integer
  "delta30_NEW_gte": number; // Integer
  "delta30_USED_lte": number; // Integer
  "delta30_USED_gte": number; // Integer
  "delta30_SALES_lte": number; // Integer
  "delta30_SALES_gte": number; // Integer
  "delta30_LISTPRICE_lte": number; // Integer
  "delta30_LISTPRICE_gte": number; // Integer
  "delta30_COLLECTIBLE_lte": number; // Integer
  "delta30_COLLECTIBLE_gte": number; // Integer
  "delta30_REFURBISHED_lte": number; // Integer
  "delta30_REFURBISHED_gte": number; // Integer
  "delta30_NEW_FBM_SHIPPING_lte": number; // Integer
  "delta30_NEW_FBM_SHIPPING_gte": number; // Integer
  "delta30_LIGHTNING_DEAL_lte": number; // Integer
  "delta30_LIGHTNING_DEAL_gte": number; // Integer
  "delta30_WAREHOUSE_lte": number; // Integer
  "delta30_WAREHOUSE_gte": number; // Integer
  "delta30_NEW_FBA_lte": number; // Integer
  "delta30_NEW_FBA_gte": number; // Integer
  "delta30_COUNT_NEW_lte": number; // Integer
  "delta30_COUNT_NEW_gte": number; // Integer
  "delta30_COUNT_USED_lte": number; // Integer
  "delta30_COUNT_USED_gte": number; // Integer
  "delta30_COUNT_REFURBISHED_lte": number; // Integer
  "delta30_COUNT_REFURBISHED_gte": number; // Integer
  "delta30_COUNT_COLLECTIBLE_lte": number; // Integer
  "delta30_COUNT_COLLECTIBLE_gte": number; // Integer
  "delta30_RATING_lte": number; // Integer
  "delta30_RATING_gte": number; // Integer
  "delta30_COUNT_REVIEWS_lte": number; // Integer
  "delta30_COUNT_REVIEWS_gte": number; // Integer
  "delta30_BUY_BOX_SHIPPING_lte": number; // Integer
  "delta30_BUY_BOX_SHIPPING_gte": number; // Integer
  "delta30_USED_NEW_SHIPPING_lte": number; // Integer
  "delta30_USED_NEW_SHIPPING_gte": number; // Integer
  "delta30_USED_VERY_GOOD_SHIPPING_lte": number; // Integer
  "delta30_USED_VERY_GOOD_SHIPPING_gte": number; // Integer
  "delta30_USED_GOOD_SHIPPING_lte": number; // Integer
  "delta30_USED_GOOD_SHIPPING_gte": number; // Integer
  "delta30_USED_ACCEPTABLE_SHIPPING_lte": number; // Integer
  "delta30_USED_ACCEPTABLE_SHIPPING_gte": number; // Integer
  "delta30_REFURBISHED_SHIPPING_lte": number; // Integer
  "delta30_REFURBISHED_SHIPPING_gte": number; // Integer
  "delta30_TRADE_IN_lte": number; // Integer
  "delta30_TRADE_IN_gte": number; // Integer
  "deltaPercent90_AMAZON_lte": number; // Integer
  "deltaPercent90_AMAZON_gte": number; // Integer
  "deltaPercent90_NEW_lte": number; // Integer
  "deltaPercent90_NEW_gte": number; // Integer
  "deltaPercent90_USED_lte": number; // Integer
  "deltaPercent90_USED_gte": number; // Integer
  "deltaPercent90_SALES_lte": number; // Integer
  "deltaPercent90_SALES_gte": number; // Integer
  "deltaPercent90_LISTPRICE_lte": number; // Integer
  "deltaPercent90_LISTPRICE_gte": number; // Integer
  "deltaPercent90_COLLECTIBLE_lte": number; // Integer
  "deltaPercent90_COLLECTIBLE_gte": number; // Integer
  "deltaPercent90_REFURBISHED_lte": number; // Integer
  "deltaPercent90_REFURBISHED_gte": number; // Integer
  "deltaPercent90_NEW_FBM_SHIPPING_lte": number; // Integer
  "deltaPercent90_NEW_FBM_SHIPPING_gte": number; // Integer
  "deltaPercent90_LIGHTNING_DEAL_lte": number; // Integer
  "deltaPercent90_LIGHTNING_DEAL_gte": number; // Integer
  "deltaPercent90_WAREHOUSE_lte": number; // Integer
  "deltaPercent90_WAREHOUSE_gte": number; // Integer
  "deltaPercent90_NEW_FBA_lte": number; // Integer
  "deltaPercent90_NEW_FBA_gte": number; // Integer
  "deltaPercent90_COUNT_NEW_lte": number; // Integer
  "deltaPercent90_COUNT_NEW_gte": number; // Integer
  "deltaPercent90_COUNT_USED_lte": number; // Integer
  "deltaPercent90_COUNT_USED_gte": number; // Integer
  "deltaPercent90_COUNT_REFURBISHED_lte": number; // Integer
  "deltaPercent90_COUNT_REFURBISHED_gte": number; // Integer
  "deltaPercent90_COUNT_COLLECTIBLE_lte": number; // Integer
  "deltaPercent90_COUNT_COLLECTIBLE_gte": number; // Integer
  "deltaPercent90_RATING_lte": number; // Integer
  "deltaPercent90_RATING_gte": number; // Integer
  "deltaPercent90_COUNT_REVIEWS_lte": number; // Integer
  "deltaPercent90_COUNT_REVIEWS_gte": number; // Integer
  "deltaPercent90_BUY_BOX_SHIPPING_lte": number; // Integer
  "deltaPercent90_BUY_BOX_SHIPPING_gte": number; // Integer
  "deltaPercent90_USED_NEW_SHIPPING_lte": number; // Integer
  "deltaPercent90_USED_NEW_SHIPPING_gte": number; // Integer
  "deltaPercent90_USED_VERY_GOOD_SHIPPING_lte": number; // Integer
  "deltaPercent90_USED_VERY_GOOD_SHIPPING_gte": number; // Integer
  "deltaPercent90_USED_GOOD_SHIPPING_lte": number; // Integer
  "deltaPercent90_USED_GOOD_SHIPPING_gte": number; // Integer
  "deltaPercent90_USED_ACCEPTABLE_SHIPPING_lte": number; // Integer
  "deltaPercent90_USED_ACCEPTABLE_SHIPPING_gte": number; // Integer
  "deltaPercent90_REFURBISHED_SHIPPING_lte": number; // Integer
  "deltaPercent90_REFURBISHED_SHIPPING_gte": number; // Integer
  "deltaPercent90_TRADE_IN_lte": number; // Integer
  "deltaPercent90_TRADE_IN_gte": number; // Integer
  "deltaPercent30_AMAZON_lte": number; // Integer
  "deltaPercent30_AMAZON_gte": number; // Integer
  "deltaPercent30_NEW_lte": number; // Integer
  "deltaPercent30_NEW_gte": number; // Integer
  "deltaPercent30_USED_lte": number; // Integer
  "deltaPercent30_USED_gte": number; // Integer
  "deltaPercent30_SALES_lte": number; // Integer
  "deltaPercent30_SALES_gte": number; // Integer
  "deltaPercent30_LISTPRICE_lte": number; // Integer
  "deltaPercent30_LISTPRICE_gte": number; // Integer
  "deltaPercent30_COLLECTIBLE_lte": number; // Integer
  "deltaPercent30_COLLECTIBLE_gte": number; // Integer
  "deltaPercent30_REFURBISHED_lte": number; // Integer
  "deltaPercent30_REFURBISHED_gte": number; // Integer
  "deltaPercent30_NEW_FBM_SHIPPING_lte": number; // Integer
  "deltaPercent30_NEW_FBM_SHIPPING_gte": number; // Integer
  "deltaPercent30_LIGHTNING_DEAL_lte": number; // Integer
  "deltaPercent30_LIGHTNING_DEAL_gte": number; // Integer
  "deltaPercent30_WAREHOUSE_lte": number; // Integer
  "deltaPercent30_WAREHOUSE_gte": number; // Integer
  "deltaPercent30_NEW_FBA_lte": number; // Integer
  "deltaPercent30_NEW_FBA_gte": number; // Integer
  "deltaPercent30_COUNT_NEW_lte": number; // Integer
  "deltaPercent30_COUNT_NEW_gte": number; // Integer
  "deltaPercent30_COUNT_USED_lte": number; // Integer
  "deltaPercent30_COUNT_USED_gte": number; // Integer
  "deltaPercent30_COUNT_REFURBISHED_lte": number; // Integer
  "deltaPercent30_COUNT_REFURBISHED_gte": number; // Integer
  "deltaPercent30_COUNT_COLLECTIBLE_lte": number; // Integer
  "deltaPercent30_COUNT_COLLECTIBLE_gte": number; // Integer
  "deltaPercent30_RATING_lte": number; // Integer
  "deltaPercent30_RATING_gte": number; // Integer
  "deltaPercent30_COUNT_REVIEWS_lte": number; // Integer
  "deltaPercent30_COUNT_REVIEWS_gte": number; // Integer
  "deltaPercent30_BUY_BOX_SHIPPING_lte": number; // Integer
  "deltaPercent30_BUY_BOX_SHIPPING_gte": number; // Integer
  "deltaPercent30_USED_NEW_SHIPPING_lte": number; // Integer
  "deltaPercent30_USED_NEW_SHIPPING_gte": number; // Integer
  "deltaPercent30_USED_VERY_GOOD_SHIPPING_lte": number; // Integer
  "deltaPercent30_USED_VERY_GOOD_SHIPPING_gte": number; // Integer
  "deltaPercent30_USED_GOOD_SHIPPING_lte": number; // Integer
  "deltaPercent30_USED_GOOD_SHIPPING_gte": number; // Integer
  "deltaPercent30_USED_ACCEPTABLE_SHIPPING_lte": number; // Integer
  "deltaPercent30_USED_ACCEPTABLE_SHIPPING_gte": number; // Integer
  "deltaPercent30_REFURBISHED_SHIPPING_lte": number; // Integer
  "deltaPercent30_REFURBISHED_SHIPPING_gte": number; // Integer
  "deltaPercent30_TRADE_IN_lte": number; // Integer
  "deltaPercent30_TRADE_IN_gte": number; // Integer
  "deltaLast_AMAZON_lte": number; // Integer
  "deltaLast_AMAZON_gte": number; // Integer
  "deltaLast_NEW_lte": number; // Integer
  "deltaLast_NEW_gte": number; // Integer
  "deltaLast_USED_lte": number; // Integer
  "deltaLast_USED_gte": number; // Integer
  "deltaLast_SALES_lte": number; // Integer
  "deltaLast_SALES_gte": number; // Integer
  "deltaLast_LISTPRICE_lte": number; // Integer
  "deltaLast_LISTPRICE_gte": number; // Integer
  "deltaLast_COLLECTIBLE_lte": number; // Integer
  "deltaLast_COLLECTIBLE_gte": number; // Integer
  "deltaLast_REFURBISHED_lte": number; // Integer
  "deltaLast_REFURBISHED_gte": number; // Integer
  "deltaLast_NEW_FBM_SHIPPING_lte": number; // Integer
  "deltaLast_NEW_FBM_SHIPPING_gte": number; // Integer
  "deltaLast_LIGHTNING_DEAL_lte": number; // Integer
  "deltaLast_LIGHTNING_DEAL_gte": number; // Integer
  "deltaLast_WAREHOUSE_lte": number; // Integer
  "deltaLast_WAREHOUSE_gte": number; // Integer
  "deltaLast_NEW_FBA_lte": number; // Integer
  "deltaLast_NEW_FBA_gte": number; // Integer
  "deltaLast_COUNT_NEW_lte": number; // Integer
  "deltaLast_COUNT_NEW_gte": number; // Integer
  "deltaLast_COUNT_USED_lte": number; // Integer
  "deltaLast_COUNT_USED_gte": number; // Integer
  "deltaLast_COUNT_REFURBISHED_lte": number; // Integer
  "deltaLast_COUNT_REFURBISHED_gte": number; // Integer
  "deltaLast_COUNT_COLLECTIBLE_lte": number; // Integer
  "deltaLast_COUNT_COLLECTIBLE_gte": number; // Integer
  "deltaLast_RATING_lte": number; // Integer
  "deltaLast_RATING_gte": number; // Integer
  "deltaLast_COUNT_REVIEWS_lte": number; // Integer
  "deltaLast_COUNT_REVIEWS_gte": number; // Integer
  "deltaLast_BUY_BOX_SHIPPING_lte": number; // Integer
  "deltaLast_BUY_BOX_SHIPPING_gte": number; // Integer
  "deltaLast_USED_NEW_SHIPPING_lte": number; // Integer
  "deltaLast_USED_NEW_SHIPPING_gte": number; // Integer
  "deltaLast_USED_VERY_GOOD_SHIPPING_lte": number; // Integer
  "deltaLast_USED_VERY_GOOD_SHIPPING_gte": number; // Integer
  "deltaLast_USED_GOOD_SHIPPING_lte": number; // Integer
  "deltaLast_USED_GOOD_SHIPPING_gte": number; // Integer
  "deltaLast_USED_ACCEPTABLE_SHIPPING_lte": number; // Integer
  "deltaLast_USED_ACCEPTABLE_SHIPPING_gte": number; // Integer
  "deltaLast_REFURBISHED_SHIPPING_lte": number; // Integer
  "deltaLast_REFURBISHED_SHIPPING_gte": number; // Integer
  "deltaLast_TRADE_IN_lte": number; // Integer
  "deltaLast_TRADE_IN_gte": number; // Integer
  "avg180_AMAZON_lte": number; // Integer
  "avg180_AMAZON_gte": number; // Integer
  "avg180_NEW_lte": number; // Integer
  "avg180_NEW_gte": number; // Integer
  "avg180_USED_lte": number; // Integer
  "avg180_USED_gte": number; // Integer
  "avg180_SALES_lte": number; // Integer
  "avg180_SALES_gte": number; // Integer
  "avg180_LISTPRICE_lte": number; // Integer
  "avg180_LISTPRICE_gte": number; // Integer
  "avg180_COLLECTIBLE_lte": number; // Integer
  "avg180_COLLECTIBLE_gte": number; // Integer
  "avg180_REFURBISHED_lte": number; // Integer
  "avg180_REFURBISHED_gte": number; // Integer
  "avg180_NEW_FBM_SHIPPING_lte": number; // Integer
  "avg180_NEW_FBM_SHIPPING_gte": number; // Integer
  "avg180_LIGHTNING_DEAL_lte": number; // Integer
  "avg180_LIGHTNING_DEAL_gte": number; // Integer
  "avg180_WAREHOUSE_lte": number; // Integer
  "avg180_WAREHOUSE_gte": number; // Integer
  "avg180_NEW_FBA_lte": number; // Integer
  "avg180_NEW_FBA_gte": number; // Integer
  "avg180_COUNT_NEW_lte": number; // Integer
  "avg180_COUNT_NEW_gte": number; // Integer
  "avg180_COUNT_USED_lte": number; // Integer
  "avg180_COUNT_USED_gte": number; // Integer
  "avg180_COUNT_REFURBISHED_lte": number; // Integer
  "avg180_COUNT_REFURBISHED_gte": number; // Integer
  "avg180_COUNT_COLLECTIBLE_lte": number; // Integer
  "avg180_COUNT_COLLECTIBLE_gte": number; // Integer
  "avg180_RATING_lte": number; // Integer
  "avg180_RATING_gte": number; // Integer
  "avg180_COUNT_REVIEWS_lte": number; // Integer
  "avg180_COUNT_REVIEWS_gte": number; // Integer
  "avg180_BUY_BOX_SHIPPING_lte": number; // Integer
  "avg180_BUY_BOX_SHIPPING_gte": number; // Integer
  "avg180_USED_NEW_SHIPPING_lte": number; // Integer
  "avg180_USED_NEW_SHIPPING_gte": number; // Integer
  "avg180_USED_VERY_GOOD_SHIPPING_lte": number; // Integer
  "avg180_USED_VERY_GOOD_SHIPPING_gte": number; // Integer
  "avg180_USED_GOOD_SHIPPING_lte": number; // Integer
  "avg180_USED_GOOD_SHIPPING_gte": number; // Integer
  "avg180_USED_ACCEPTABLE_SHIPPING_lte": number; // Integer
  "avg180_USED_ACCEPTABLE_SHIPPING_gte": number; // Integer
  "avg180_REFURBISHED_SHIPPING_lte": number; // Integer
  "avg180_REFURBISHED_SHIPPING_gte": number; // Integer
  "avg180_TRADE_IN_lte": number; // Integer
  "avg180_TRADE_IN_gte": number; // Integer
  "avg90_AMAZON_lte": number; // Integer
  "avg90_AMAZON_gte": number; // Integer
  "avg90_NEW_lte": number; // Integer
  "avg90_NEW_gte": number; // Integer
  "avg90_USED_lte": number; // Integer
  "avg90_USED_gte": number; // Integer
  "avg90_SALES_lte": number; // Integer
  "avg90_SALES_gte": number; // Integer
  "avg90_LISTPRICE_lte": number; // Integer
  "avg90_LISTPRICE_gte": number; // Integer
  "avg90_COLLECTIBLE_lte": number; // Integer
  "avg90_COLLECTIBLE_gte": number; // Integer
  "avg90_REFURBISHED_lte": number; // Integer
  "avg90_REFURBISHED_gte": number; // Integer
  "avg90_NEW_FBM_SHIPPING_lte": number; // Integer
  "avg90_NEW_FBM_SHIPPING_gte": number; // Integer
  "avg90_LIGHTNING_DEAL_lte": number; // Integer
  "avg90_LIGHTNING_DEAL_gte": number; // Integer
  "avg90_WAREHOUSE_lte": number; // Integer
  "avg90_WAREHOUSE_gte": number; // Integer
  "avg90_NEW_FBA_lte": number; // Integer
  "avg90_NEW_FBA_gte": number; // Integer
  "avg90_COUNT_NEW_lte": number; // Integer
  "avg90_COUNT_NEW_gte": number; // Integer
  "avg90_COUNT_USED_lte": number; // Integer
  "avg90_COUNT_USED_gte": number; // Integer
  "avg90_COUNT_REFURBISHED_lte": number; // Integer
  "avg90_COUNT_REFURBISHED_gte": number; // Integer
  "avg90_COUNT_COLLECTIBLE_lte": number; // Integer
  "avg90_COUNT_COLLECTIBLE_gte": number; // Integer
  "avg90_RATING_lte": number; // Integer
  "avg90_RATING_gte": number; // Integer
  "avg90_COUNT_REVIEWS_lte": number; // Integer
  "avg90_COUNT_REVIEWS_gte": number; // Integer
  "avg90_BUY_BOX_SHIPPING_lte": number; // Integer
  "avg90_BUY_BOX_SHIPPING_gte": number; // Integer
  "avg90_USED_NEW_SHIPPING_lte": number; // Integer
  "avg90_USED_NEW_SHIPPING_gte": number; // Integer
  "avg90_USED_VERY_GOOD_SHIPPING_lte": number; // Integer
  "avg90_USED_VERY_GOOD_SHIPPING_gte": number; // Integer
  "avg90_USED_GOOD_SHIPPING_lte": number; // Integer
  "avg90_USED_GOOD_SHIPPING_gte": number; // Integer
  "avg90_USED_ACCEPTABLE_SHIPPING_lte": number; // Integer
  "avg90_USED_ACCEPTABLE_SHIPPING_gte": number; // Integer
  "avg90_REFURBISHED_SHIPPING_lte": number; // Integer
  "avg90_REFURBISHED_SHIPPING_gte": number; // Integer
  "avg90_TRADE_IN_lte": number; // Integer
  "avg90_TRADE_IN_gte": number; // Integer
  "avg30_AMAZON_lte": number; // Integer
  "avg30_AMAZON_gte": number; // Integer
  "avg30_NEW_lte": number; // Integer
  "avg30_NEW_gte": number; // Integer
  "avg30_USED_lte": number; // Integer
  "avg30_USED_gte": number; // Integer
  "avg30_SALES_lte": number; // Integer
  "avg30_SALES_gte": number; // Integer
  "avg30_LISTPRICE_lte": number; // Integer
  "avg30_LISTPRICE_gte": number; // Integer
  "avg30_COLLECTIBLE_lte": number; // Integer
  "avg30_COLLECTIBLE_gte": number; // Integer
  "avg30_REFURBISHED_lte": number; // Integer
  "avg30_REFURBISHED_gte": number; // Integer
  "avg30_NEW_FBM_SHIPPING_lte": number; // Integer
  "avg30_NEW_FBM_SHIPPING_gte": number; // Integer
  "avg30_LIGHTNING_DEAL_lte": number; // Integer
  "avg30_LIGHTNING_DEAL_gte": number; // Integer
  "avg30_WAREHOUSE_lte": number; // Integer
  "avg30_WAREHOUSE_gte": number; // Integer
  "avg30_NEW_FBA_lte": number; // Integer
  "avg30_NEW_FBA_gte": number; // Integer
  "avg30_COUNT_NEW_lte": number; // Integer
  "avg30_COUNT_NEW_gte": number; // Integer
  "avg30_COUNT_USED_lte": number; // Integer
  "avg30_COUNT_USED_gte": number; // Integer
  "avg30_COUNT_REFURBISHED_lte": number; // Integer
  "avg30_COUNT_REFURBISHED_gte": number; // Integer
  "avg30_COUNT_COLLECTIBLE_lte": number; // Integer
  "avg30_COUNT_COLLECTIBLE_gte": number; // Integer
  "avg30_RATING_lte": number; // Integer
  "avg30_RATING_gte": number; // Integer
  "avg30_COUNT_REVIEWS_lte": number; // Integer
  "avg30_COUNT_REVIEWS_gte": number; // Integer
  "avg30_BUY_BOX_SHIPPING_lte": number; // Integer
  "avg30_BUY_BOX_SHIPPING_gte": number; // Integer
  "avg30_USED_NEW_SHIPPING_lte": number; // Integer
  "avg30_USED_NEW_SHIPPING_gte": number; // Integer
  "avg30_USED_VERY_GOOD_SHIPPING_lte": number; // Integer
  "avg30_USED_VERY_GOOD_SHIPPING_gte": number; // Integer
  "avg30_USED_GOOD_SHIPPING_lte": number; // Integer
  "avg30_USED_GOOD_SHIPPING_gte": number; // Integer
  "avg30_USED_ACCEPTABLE_SHIPPING_lte": number; // Integer
  "avg30_USED_ACCEPTABLE_SHIPPING_gte": number; // Integer
  "avg30_REFURBISHED_SHIPPING_lte": number; // Integer
  "avg30_REFURBISHED_SHIPPING_gte": number; // Integer
  "avg30_TRADE_IN_lte": number; // Integer
  "avg30_TRADE_IN_gte": number; // Integer
  "avg365_AMAZON_lte": number; // Integer
  "avg365_AMAZON_gte": number; // Integer
  "avg365_BUY_BOX_SHIPPING_lte": number; // Integer
  "avg365_BUY_BOX_SHIPPING_gte": number; // Integer
  "avg365_BUY_BOX_USED_SHIPPING_lte": number; // Integer
  "avg365_BUY_BOX_USED_SHIPPING_gte": number; // Integer
  "avg365_COLLECTIBLE_lte": number; // Integer
  "avg365_COLLECTIBLE_gte": number; // Integer
  "avg365_COUNT_COLLECTIBLE_lte": number; // Integer
  "avg365_COUNT_COLLECTIBLE_gte": number; // Integer
  "avg365_COUNT_NEW_lte": number; // Integer
  "avg365_COUNT_NEW_gte": number; // Integer
  "avg365_COUNT_REFURBISHED_lte": number; // Integer
  "avg365_COUNT_REFURBISHED_gte": number; // Integer
  "avg365_COUNT_REVIEWS_lte": number; // Integer
  "avg365_COUNT_REVIEWS_gte": number; // Integer
  "avg365_COUNT_USED_lte": number; // Integer
  "avg365_COUNT_USED_gte": number; // Integer
  "avg365_EBAY_NEW_SHIPPING_lte": number; // Integer
  "avg365_EBAY_NEW_SHIPPING_gte": number; // Integer
  "avg365_EBAY_USED_SHIPPING_lte": number; // Integer
  "avg365_EBAY_USED_SHIPPING_gte": number; // Integer
  "avg365_LIGHTNING_DEAL_lte": number; // Integer
  "avg365_LIGHTNING_DEAL_gte": number; // Integer
  "avg365_LISTPRICE_lte": number; // Integer
  "avg365_LISTPRICE_gte": number; // Integer
  "avg365_NEW_lte": number; // Integer
  "avg365_NEW_gte": number; // Integer
  "avg365_NEW_FBA_lte": number; // Integer
  "avg365_NEW_FBA_gte": number; // Integer
  "avg365_NEW_FBM_SHIPPING_lte": number; // Integer
  "avg365_NEW_FBM_SHIPPING_gte": number; // Integer
  "avg365_PRIME_EXCL_lte": number; // Integer
  "avg365_PRIME_EXCL_gte": number; // Integer
  "avg365_RATING_lte": number; // Integer
  "avg365_RATING_gte": number; // Integer
  "avg365_REFURBISHED_lte": number; // Integer
  "avg365_REFURBISHED_gte": number; // Integer
  "avg365_REFURBISHED_SHIPPING_lte": number; // Integer
  "avg365_REFURBISHED_SHIPPING_gte": number; // Integer
  "avg365_RENT_lte": number; // Integer
  "avg365_RENT_gte": number; // Integer
  "avg365_SALES_lte": number; // Integer
  "avg365_SALES_gte": number; // Integer
  "avg365_TRADE_IN_lte": number; // Integer
  "avg365_TRADE_IN_gte": number; // Integer
  "avg365_USED_lte": number; // Integer
  "avg365_USED_gte": number; // Integer
  "avg365_USED_ACCEPTABLE_SHIPPING_lte": number; // Integer
  "avg365_USED_ACCEPTABLE_SHIPPING_gte": number; // Integer
  "avg365_USED_GOOD_SHIPPING_lte": number; // Integer
  "avg365_USED_GOOD_SHIPPING_gte": number; // Integer
  "avg365_USED_NEW_SHIPPING_lte": number; // Integer
  "avg365_USED_NEW_SHIPPING_gte": number; // Integer
  "avg365_USED_VERY_GOOD_SHIPPING_lte": number; // Integer
  "avg365_USED_VERY_GOOD_SHIPPING_gte": number; // Integer
  "avg365_WAREHOUSE_lte": number; // Integer
  "avg365_WAREHOUSE_gte": number; // Integer

  "lastPriceChange_AMAZON_lte": number; // Integer
  "lastPriceChange_AMAZON_gte": number; // Integer
  "lastPriceChange_NEW_lte": number; // Integer
  "lastPriceChange_NEW_gte": number; // Integer
  "lastPriceChange_USED_lte": number; // Integer
  "lastPriceChange_USED_gte": number; // Integer
  "lastPriceChange_SALES_lte": number; // Integer
  "lastPriceChange_SALES_gte": number; // Integer
  "lastPriceChange_LISTPRICE_lte": number; // Integer
  "lastPriceChange_LISTPRICE_gte": number; // Integer
  "lastPriceChange_COLLECTIBLE_lte": number; // Integer
  "lastPriceChange_COLLECTIBLE_gte": number; // Integer
  "lastPriceChange_REFURBISHED_lte": number; // Integer
  "lastPriceChange_REFURBISHED_gte": number; // Integer
  "lastPriceChange_NEW_FBM_SHIPPING_lte": number; // Integer
  "lastPriceChange_NEW_FBM_SHIPPING_gte": number; // Integer
  "lastPriceChange_LIGHTNING_DEAL_lte": number; // Integer
  "lastPriceChange_LIGHTNING_DEAL_gte": number; // Integer
  "lastPriceChange_WAREHOUSE_lte": number; // Integer
  "lastPriceChange_WAREHOUSE_gte": number; // Integer
  "lastPriceChange_NEW_FBA_lte": number; // Integer
  "lastPriceChange_NEW_FBA_gte": number; // Integer
  "lastPriceChange_COUNT_NEW_lte": number; // Integer
  "lastPriceChange_COUNT_NEW_gte": number; // Integer
  "lastPriceChange_COUNT_USED_lte": number; // Integer
  "lastPriceChange_COUNT_USED_gte": number; // Integer
  "lastPriceChange_COUNT_REFURBISHED_lte": number; // Integer
  "lastPriceChange_COUNT_REFURBISHED_gte": number; // Integer
  "lastPriceChange_COUNT_COLLECTIBLE_lte": number; // Integer
  "lastPriceChange_COUNT_COLLECTIBLE_gte": number; // Integer
  "lastPriceChange_RATING_lte": number; // Integer
  "lastPriceChange_RATING_gte": number; // Integer
  "lastPriceChange_COUNT_REVIEWS_lte": number; // Integer
  "lastPriceChange_COUNT_REVIEWS_gte": number; // Integer
  "lastPriceChange_BUY_BOX_SHIPPING_lte": number; // Integer
  "lastPriceChange_BUY_BOX_SHIPPING_gte": number; // Integer
  "lastPriceChange_USED_NEW_SHIPPING_lte": number; // Integer
  "lastPriceChange_USED_NEW_SHIPPING_gte": number; // Integer
  "lastPriceChange_USED_VERY_GOOD_SHIPPING_lte": number; // Integer
  "lastPriceChange_USED_VERY_GOOD_SHIPPING_gte": number; // Integer
  "lastPriceChange_USED_GOOD_SHIPPING_lte": number; // Integer
  "lastPriceChange_USED_GOOD_SHIPPING_gte": number; // Integer
  "lastPriceChange_USED_ACCEPTABLE_SHIPPING_lte": number; // Integer
  "lastPriceChange_USED_ACCEPTABLE_SHIPPING_gte": number; // Integer
  "lastPriceChange_REFURBISHED_SHIPPING_lte": number; // Integer
  "lastPriceChange_REFURBISHED_SHIPPING_gte": number; // Integer
  "lastPriceChange_EBAY_NEW_SHIPPING_lte": number; // Integer
  "lastPriceChange_EBAY_NEW_SHIPPING_gte": number; // Integer
  "lastPriceChange_EBAY_USED_SHIPPING_lte": number; // Integer
  "lastPriceChange_EBAY_USED_SHIPPING_gte": number; // Integer
  "lastPriceChange_TRADE_IN_lte": number; // Integer
  "lastPriceChange_TRADE_IN_gte": number; // Integer
  "lastPriceChange_RENT_lte": number; // Integer
  "lastPriceChange_RENT_gte": number; // Integer
  "lastPriceChange_BUY_BOX_USED_SHIPPING_lte": number; // Integer
  "lastPriceChange_BUY_BOX_USED_SHIPPING_gte": number; // Integer
  "lastPriceChange_PRIME_EXCL_lte": number; // Integer
  "lastPriceChange_PRIME_EXCL_gte": number; // Integer
  
  "backInStock_AMAZON": boolean;
  "backInStock_NEW": boolean;
  "backInStock_USED": boolean;
  "backInStock_SALES": boolean;
  "backInStock_LISTPRICE": boolean;
  "backInStock_COLLECTIBLE": boolean;
  "backInStock_REFURBISHED": boolean;
  "backInStock_NEW_FBM_SHIPPING": boolean;
  "backInStock_LIGHTNING_DEAL": boolean;
  "backInStock_WAREHOUSE": boolean;
  "backInStock_NEW_FBA": boolean;
  "backInStock_COUNT_NEW": boolean;
  "backInStock_COUNT_USED": boolean;
  "backInStock_COUNT_REFURBISHED": boolean;
  "backInStock_COUNT_COLLECTIBLE": boolean;
  "backInStock_RATING": boolean;
  "backInStock_COUNT_REVIEWS": boolean;
  "backInStock_BUY_BOX_SHIPPING": boolean;
  "backInStock_USED_NEW_SHIPPING": boolean;
  "backInStock_USED_VERY_GOOD_SHIPPING": boolean;
  "backInStock_USED_GOOD_SHIPPING": boolean;
  "backInStock_USED_ACCEPTABLE_SHIPPING": boolean;
  "backInStock_REFURBISHED_SHIPPING": boolean;
  "backInStock_TRADE_IN": boolean;

  "isLowest_AMAZON": boolean;
  "isLowest_BUY_BOX_SHIPPING": boolean;
  "isLowest_BUY_BOX_USED_SHIPPING": boolean;
  "isLowest_COLLECTIBLE": boolean;
  "isLowest_COUNT_COLLECTIBLE": boolean;
  "isLowest_COUNT_NEW": boolean;
  "isLowest_COUNT_REFURBISHED": boolean;
  "isLowest_COUNT_REVIEWS": boolean;
  "isLowest_COUNT_USED": boolean;
  "isLowest_EBAY_NEW_SHIPPING": boolean;
  "isLowest_EBAY_USED_SHIPPING": boolean;
  "isLowest_LIGHTNING_DEAL": boolean;
  "isLowest_LISTPRICE": boolean;
  "isLowest_NEW": boolean;
  "isLowest_NEW_FBA": boolean;
  "isLowest_NEW_FBM_SHIPPING": boolean;
  "isLowest_PRIME_EXCL": boolean;
  "isLowest_RATING": boolean;
  "isLowest_REFURBISHED": boolean;
  "isLowest_REFURBISHED_SHIPPING": boolean;
  "isLowest_RENT": boolean;
  "isLowest_SALES": boolean;
  "isLowest_TRADE_IN": boolean;
  "isLowest_USED": boolean;
  "isLowest_USED_ACCEPTABLE_SHIPPING": boolean;
  "isLowest_USED_GOOD_SHIPPING": boolean;
  "isLowest_USED_NEW_SHIPPING": boolean;
  "isLowest_USED_VERY_GOOD_SHIPPING": boolean;
  "isLowest_WAREHOUSE": boolean;
  "isLowest90_AMAZON": boolean;
  "isLowest90_BUY_BOX_SHIPPING": boolean;
  "isLowest90_BUY_BOX_USED_SHIPPING": boolean;
  "isLowest90_COLLECTIBLE": boolean;
  "isLowest90_COUNT_COLLECTIBLE": boolean;
  "isLowest90_COUNT_NEW": boolean;
  "isLowest90_COUNT_REFURBISHED": boolean;
  "isLowest90_COUNT_REVIEWS": boolean;
  "isLowest90_COUNT_USED": boolean;
  "isLowest90_EBAY_NEW_SHIPPING": boolean;
  "isLowest90_EBAY_USED_SHIPPING": boolean;
  "isLowest90_LIGHTNING_DEAL": boolean;
  "isLowest90_LISTPRICE": boolean;
  "isLowest90_NEW": boolean;
  "isLowest90_NEW_FBA": boolean;
  "isLowest90_NEW_FBM_SHIPPING": boolean;
  "isLowest90_PRIME_EXCL": boolean;
  "isLowest90_RATING": boolean;
  "isLowest90_REFURBISHED": boolean;
  "isLowest90_REFURBISHED_SHIPPING": boolean;
  "isLowest90_RENT": boolean;
  "isLowest90_SALES": boolean;
  "isLowest90_TRADE_IN": boolean;
  "isLowest90_USED": boolean;
  "isLowest90_USED_ACCEPTABLE_SHIPPING": boolean;
  "isLowest90_USED_GOOD_SHIPPING": boolean;
  "isLowest90_USED_NEW_SHIPPING": boolean;
  "isLowest90_USED_VERY_GOOD_SHIPPING": boolean;
  "isLowest90_WAREHOUSE": boolean
}

export interface KeepaProduct {
  "productType": number, // Integer
  "asin": string, // String
  "domainId": number, // Integer
  "title": string, // String
  "trackingSince": number, // Integer
  "listedSince": number, // Integer
  "lastUpdate": number, // Integer
  "lastRatingUpdate": number, // Integer 
  "lastPriceChange": number, // Integer
  "lastEbayUpdate": number, // Integer
  "lastStockUpdate": number, // Integer
  "imagesCSV": string, // String
  "rootCategory": number, // Integer
  "categories": number[], // Long array
  "categoryTree": object[], // Object array
  "parentAsin": string, // String
  "parentAsinHistory": string[], // String array
  "frequentlyBoughtTogether": string[], // String array
  "eanList": string[], // String array
  "upcList": string[], // String array
  "manufacturer": string, // String
  "brand": string, // String
  "brandStoreName": string, // String
  "brandStoreUrl": string, // String
  "brandStoreUrlName": string, // String
  "productGroup": string, // String
  "type": string, // String
  "partNumber": string, // String
  "binding": string, // String
  "scent": string, // String
  "shortDescription": string, // String
  "activeIngredients": string, // String
  "specialIngredients": string, // String
  "itemForm": string, // String
  "itemTypeKeyword": string, // String
  "recommendedUsesForProduct": string, // String
  "pattern": string, // String
  "specificUsesForProduct": string[], // String array
  "businessDiscount": number, // Integer
  "lastBusinessDiscountUpdate": number, // Integer
  "safetyWarning": string, // String
  "productBenefit": string, // String
  "batteriesRequired": boolean,
  "batteriesIncluded": boolean,
  "targetAudienceKeyword": string, // String
  "style": string, // String
  "includedComponents": string, // String
  "material": string, // String
  "numberOfItems": number, // Integer
  "numberOfPages": number, // Integer
  "publicationDate": number, // Integer
  "releaseDate": number, // Integer
  "contributors": string[][], // two dimensional String array
  "languages": string[][], // two dimensional String array
  "model": string, // String
  "color": string, // String
  "size": string, // String
  "edition": string, // String
  "format": string, // String
  "features": string[], // String array
  "description": string, // String
  "hazardousMaterials": object[], // Object array
  "videos": object[], // Object array
  "aPlus": object[], // Object array
  "packageHeight": number, // Integer
  "packageLength": number, // Integer
  "packageWidth": number, // Integer
  "packageWeight": number, // Integer
  "packageQuantity": number, // Integer
  "itemHeight": number, // Integer
  "itemLength": number, // Integer
  "itemWidth": number, // Integer
  "itemWeight": number, // Integer
  "availabilityAmazon": number, // Integer
  "availabilityAmazonDelay": number[], // Integer array
  "buyBoxEligibleOfferCounts": number[], // Integer array
  "competitivePriceThreshold": number, // Integer
  "suggestedLowerPrice": number, // Integer
  "ebayListingIds": number[], // Long array
  "isAdultProduct": boolean,
  "isHeatSensitive": boolean,
  "isMerchOnDemand": boolean,
  "isHaul": boolean,
  "launchpad": boolean,
  "audienceRating": string, // String
  "ingredients": string, // String
  "urlSlug": string, // String
  "returnRate": number, // Integer
  "newPriceIsMAP": boolean,
  "isEligibleForTradeIn": boolean,
  "isEligibleForSuperSaverShipping": boolean,
  "fbaFees": object,
  "variableClosingFee": number, // Integer
  "referralFeePercentage": number, // Double
  "variations": object[], // Object array
  "coupon": number[], // Integer array
  "couponHistory": number[], // Integer array
  "promotions": object[], // Promotion Object array
  "unitCount": object,
  "stats": KeepaStatistics, // Statistics Object
  "salesRankReference": number, // Long
  "salesRankReferenceHistory": number[], // Long array
  "salesRanks": object,
  "lastSoldUpdate": number, // Integer
  "monthlySold": number, // Integer
  "monthlySoldHistory": number[], // Integer array
  "rentalDetails": string, // String
  "rentalSellerId": string, // String
  "rentalPrices": object, // Rental Object,
  "reviews": object, // Review Object,
  "offers": object[], // Marketplace Offer Object array,
  "liveOffersOrder": number[], // Integer array
  "buyBoxSellerIdHistory": string[], // String array
  "buyBoxUsedHistory": string[], // String array
  "isRedirectASIN": boolean,
  "isSNS": boolean,
  "offersSuccessful": boolean,
  "csv": number[][], // two dimensional Integer array
}

// https://keepa.com/#!discuss/t/statistics-object/1308
export interface KeepaStatistics {
  "current": number[], // Integer array
  "avg": number[], // Integer array
  "avg30": number[], // Integer array
  "avg90": number[], // Integer array
  "avg180": number[], // Integer array
  "avg365": number[], // Integer array
  "atIntervalStart": number[], // Integer array
  "min": number[][], // two-dimensional Integer array,
  "max": number[][], // two-dimensional Integer array,
  "minInInterval": number[][], // two-dimensional Integer array,
  "maxInInterval": number[][], // two-dimensional Integer array,
  "outOfStockPercentageInInterval": number[], // Integer array
  "outOfStockPercentage30": number[], // Integer array
  "outOfStockPercentage90": number[], // Integer array
  "outOfStockPercentage180": number[], // Integer array
  "outOfStockPercentage365": number[], // Integer array
  "lastOffersUpdate": number, // Integer,
  "salesRankDrops30": number, // Integer,
  "salesRankDrops90": number, // Integer,
  "salesRankDrops180": number, // Integer,
  "salesRankDrops365": number, // Integer,
  "totalOfferCount": number, // Integer,
  "lightningDealInfo": number[], // Integer array

  // The following fields are only set if the offers or buybox parameter was used
  "lastBuyBoxUpdate": number, // Integer,
  "buyBoxSellerId": String,
  "buyBoxPrice": number, // Integer,
  "buyBoxShipping": number, // Integer,
  "buyBoxIsUnqualified": boolean,
  "buyBoxIsShippable": boolean,
  "buyBoxIsPreorder": boolean,
  "buyBoxIsBackorder": boolean,
  "buyBoxIsFBA": boolean,
  "buyBoxIsAmazon": boolean,
  "buyBoxIsMAP": boolean,
  "buyBoxMinOrderQuantity": number, // Integer,
  "buyBoxMaxOrderQuantity": number, // Integer,
  "buyBoxAvailabilityMessage": String,
  "buyBoxShippingCountry": String,
  "buyBoxIsPrimeExclusive": boolean,
  "buyBoxIsPrimeEligible": boolean,
  "buyBoxIsPrimePantry": boolean,
  "buyBoxStats": Object,
  "buyBoxUsedStats": Object,
  "buyBoxUsedPrice": number, // Integer,
  "buyBoxUsedShipping": number, // Integer,
  "buyBoxUsedSellerId": String,
  "buyBoxUsedIsFBA": boolean,
  "buyBoxUsedCondition": number, // Integer,

  // The following fields are only set if the offers parameter was used
  "retrievedOfferCount": number, // Integer,
  "isAddonItem": boolean,
  "sellerIdsLowestFBA": string[], // String array
  "sellerIdsLowestFBM": string[], // String array
  "offerCountFBA": number, // Integer,
  "offerCountFBM": number, // Integer,

  // The following fields are only set if the stock parameter was used
  "stockAmazon": number, // Integer,
  "stockBuyBox": number, // Integer
}

// https://keepa.com/#!discuss/t/category-object/115
// Category Object
export interface KeepaCategory {
  "domainId": number, // Integer
  "catId": number, // Long
  "name": string,
  "contextFreeName": string,
  "websiteDisplayGroup": string,
  "children": number[], // Long[],
  "parent": number, // Long,
  "isBrowseNode": boolean,
  "highestRank": number, // Integer
  "lowestRank": number, // Integer
  "productCount": number, // Integer
}
